/* eslint-disable no-console */
import {
  SEARCH_PAGE_TYPE,
  PRODUCT_LIST_PAGE_TYPE
} from '../constants';
import { fetchFoundryResponse } from '../actions/foundry_response';
import { setLastFetchedLocation } from '../actions/api';
import { setVariants } from '../actions/experiments';
import { onExternalSite, renderingOnServer, onProduction } from './env';
import { stringify } from 'querystring';
import { compose } from 'redux';
import {isEqual, includes, mapValues} from 'lodash';
import { getDevPaths } from './getDevPageConfig';


const SPA_NAVIGABLE_PAGE_TYPES = [
  /*
   * This list should ONLY include site templates in which the query string state
   * is double-bound to the API response.
   *
   * Example:
   * -
   * Performing a search from the interface on a search page will
   * 1) produce a change in the user-facing query string, and
   * 2) trigger a concurrent API fetch.
   *
   * Counter-example:
   * -
   * Clicking "More Stories" on a channel page will fetch more stories without
   * changing the user-facing query string. Even though channel pages will
   * technically respect "page=" query params on the initial fetch, this does not
   * occur on subsequent fetches - and so the CHANNEL_PAGE_TYPE does not belong
   * here.
   */
  PRODUCT_LIST_PAGE_TYPE,
  SEARCH_PAGE_TYPE
];

const asJson = compose(
  stringify,
  query => ({ ...query, json: true })
);

export const shouldFetch = (nextState, store) => {
  if (renderingOnServer() || onExternalSite()) {
    return false;
  }

  const {
    analytics: { page_type },
    api: {
      lastFetchedLocation,
      isInitialPageview
    }
  } = store.getState();

  /*
   * Block any client side fetches on initial page load on production since we
   * already made a request to foundry via the server.
   *
   * We need the check against production since we do still need to make a client side
   * request for `gulp dev`.
   */
  if (onProduction() && isInitialPageview) {
    return false;
  }

  const pathnameHasChanged = (
    nextState.location.pathname
    !==
    lastFetchedLocation.pathname
  );

  if (includes(SPA_NAVIGABLE_PAGE_TYPES, page_type) && !pathnameHasChanged) {
    return !isEqual(
      nextState.location.query,
      mapValues(lastFetchedLocation.query, decodeURIComponent)
    );
  }

  return pathnameHasChanged;
};

/*
 * Async function invoked in the context of React Router
 * onEnter/onChange callbacks.
 *
 * It clears out the article and modules, and makes a proxied
 * API request.
 */
export default (nextState, fetchType, store) => {
  const { location } = nextState;
  const { pathname, query } = location;

  let apiUrl = '';

  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line quotes

    // returns /en-us/ss-article into us
    const country = pathname.split('/')[1].split('-')[1] || 'us';

    // grabs getDevPageCong edition objects
    const pathNames = getDevPaths(pathname, query);

    let urlPath;
    // checks for en-us or en-us/rr-article
    urlPath = 'aggregation/1';
    if (pathname.length > 7) {
      const urlArray = pathname.split('/');
      urlPath = `blog_entry/${pathNames['/' + urlArray[urlArray.length - 1]].type_id}`;
      //urlPath = `blog_entry/${pathNames['/' + url.split('/')[2]].type_id}`;
    }

    apiUrl = `http://localhost:4567/wp-json/r29/v1/rosetta/${country}/${urlPath}`;

  } else {
    apiUrl = pathname + '?' + asJson(query);
  }

  const fetchAction = fetchFoundryResponse(apiUrl, fetchType);
  return store.dispatch(fetchAction).then(() => {
    store.dispatch(setVariants(store.getState().cookies));
    return store.dispatch(setLastFetchedLocation(location));
  });
};
